// extracted by mini-css-extract-plugin
module.exports = {"component":"style_component__SpMh1","title":"style_title__mk6II","component-full-screen":"style_component-full-screen__OAARZ","borderless":"style_borderless__vn3QM"};